import * as types from './mutation-types'

export default {
  [types.SET_MEASURES] (state, payload) {
    state.measures = payload
  },
  [types.SET_MEASURE] (state, payload) {
    state.measure = payload
  },
  [types.SET_PAGINATION] (state, payload) {
    state.pagination = payload
  }
}
